import { ComponentsAddressMapper } from "@omni/mappers/customer/address.mapper";
import { AddressType } from "@omni/types/api/customer/cloud/shared/enums/addressType.enum";

import { CustomerAddress } from "@/components/Address/Address/address.component";
import { OrderCustomerModel } from "@/redux/modules/api/data/orderDetail/@types/orderCustomer.model";
import { OrderDetailsModel } from "@/redux/modules/api/data/orderDetail/@types/orderDetails.model";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const OrderCustomerDetailsBlock = ({
    orderObject,
    customerObject
}: {
    orderObject: OrderDetailsModel;
    customerObject: OrderCustomerModel;
}) => {
    const { t } = useGranite();

    return (
        <>
            {orderObject.billingAddress && (
                <div className="mb-4">
                    <h4>{t("orderOverview.label.billingAddress")}</h4>
                    {customerObject.isB2BClient && (
                        <p>
                            <div>{customerObject.companyName}</div>
                            <div>{customerObject.vatNumber}</div>
                        </p>
                    )}
                    <CustomerAddress
                        address={ComponentsAddressMapper.fromCloudCustomerOrder(
                            orderObject.billingAddress
                        )}
                        addressType={AddressType.Payment}
                    />
                </div>
            )}
            {customerObject && (
                <div className="mb-4">
                    <h4>{t("orderOverview.title.contact")}</h4>
                    <div>
                        {`${customerObject.firstName} ${customerObject.lastName}`}
                        <br />
                        {customerObject.email}
                        <br />
                        {customerObject.phone || ""}
                    </div>
                </div>
            )}
        </>
    );
};

export default OrderCustomerDetailsBlock;
